export const SectionCodes = {
    RecruitingJobGrid: 'recruiting-job-grid',
    RecruitingQualifiedCandidatesTab: 'recruiting-qualified-candidates-tab'
} as const;

export type SectionCode = (typeof SectionCodes)[keyof typeof SectionCodes];
